<script>
	import { Sprout } from 'lucide-svelte';

	export let iconClass = '';
</script>

<Sprout class={iconClass} />